let settings = null,
	tbSearch = null,
	gridMain = null,
	selectedRows = '',
	pjqKeepAlive = null;

PJQ.views.publicProjects = {};
PJQ.views.publicProjects.PublicProjects = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PUBLICPROJECTS, 'Master', {isOldModule: true}),
		isAdmin: false,
		punchListItemId: null
	},
	afterRender: function () {
		if (this.options.masterUserId > 0) {
			window.publicProjectMuid = this.options.masterUserId;
		}

		PanteraScript.PanteraScriptService.GetPublicProjectSettings(PJQ.app.session.id, GetPublicProjectSettingsC, null);
	}
});


if (PJQ.app.module !== PJQ.constants.modules.APP) {
	PJQ.app.attachReadyEvent(function () {
		PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PUBLICPROJECTS, 'Master', {isOldModule: true}), $('#pjq-public-projects-main'), null, function () {
			PanteraScript.PanteraScriptService.GetPublicProjectSettings(pjqSessionId, GetPublicProjectSettingsC, null);
			pjqKeepAlive = setTimeout(KeepAlive, 300000);
		});
	});
}

function GetPublicProjectSettingsC(response) {
	settings = $.parseJSON(response);

	tbSearch = new dhtmlXToolbarObject("main-search");
	tbSearch.setSkin("dhx_web");
	tbSearch.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbSearch.addInput('search_for', 2, '', 400);
	tbSearch.addSeparator("search_for_sep", 3);
	tbSearch.addText('pc_label', 4, 'Zip');
	tbSearch.addInput('postal_code', 5, '', 100);
	tbSearch.addSeparator("postal_code_sep", 6);

	var radiusOpts = new Array();
	radiusOpts.push(new Array('radius_0', 'obj', 'Any Distance', ''));
	radiusOpts.push(new Array('radius_10', 'obj', '10 Miles', ''));
	radiusOpts.push(new Array('radius_25', 'obj', '25 Miles', ''));
	radiusOpts.push(new Array('radius_50', 'obj', '50 Miles', ''));
	radiusOpts.push(new Array('radius_100', 'obj', '100 Miles', ''));
	radiusOpts.push(new Array('radius_150', 'obj', '150 Miles', ''));
	radiusOpts.push(new Array('radius_200', 'obj', '200 Miles', ''));
	radiusOpts.push(new Array('radius_250', 'obj', '250 Miles', ''));
	tbSearch.addButtonSelect("radius", 7, "Radius", radiusOpts, "");
	tbSearch.setListOptionSelected('radius', radiusOpts[0][0]);
	tbSearch.addSeparator("radius_sep", 8);

	tbSearch.addButton("search", 10, "Search/Refresh", "action_search.gif", "");
	tbSearch.addSeparator("search_sep", 11);
	tbSearch.addButton("clear", 12, "Clear All", "", "");
	tbSearch.addSeparator("clear_sep", 13);
	tbSearch.attachEvent("onClick", function (id) {
		if (id == 'search') {
			InitializePubProjGridMain();
		}
		else if (id == 'clear') {
			tbSearch.setValue('search_for', '');
			InitializePubProjGridMain();
		}
	});


	jQuery('input.inp').keypress(function (event) {
		if (event.which == 13) {
			event.preventDefault();
			InitializePubProjGridMain();
		}
	});

	if (settings.IsSearchHidden)
		jQuery('#main-search').hide();

	InitializePubProjGridMain();
}


function InitializePubProjGridMain() {
	gridMain = new dhtmlXGridObject('grid-main');
	gridMain.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/'); //path to images required by grid
	gridMain.enableMultiline(true);
	gridMain.setSkin(pjqGridTheme);

	if (settings.ProjectListRowsPerPage > 0) {
		jQuery('#grid-main-paging').removeClass('pjq-hidden');
		gridMain.enablePaging(true, settings.ProjectListRowsPerPage, 3, "grid-main-paging");
		gridMain.setPagingSkin("toolbar", 'dhx_web');

		gridMain.attachEvent("onPageChanged", function (ind, fInd, lInd) {
			jQuery(window).scrollTop(0);
		});
	}
	else
		jQuery('#grid-main-paging').addClass('pjq-hidden');

	jQuery('#grid-main').css('width', '100%');
	gridMain.init();
	dhtmlxEvent(window, "resize", function () {
		jQuery('#grid-main, #grid-main div table').css('width', '100%');
		jQuery('#grid-main div table tbody tr th').css('width', '');
		gridMain.setSizes();
	});
	gridMain.enableAutoHeight(true);
	//gridMain.enableAutoWidth(true);

	if (settings.IsAlternatingRowColor)
		gridMain.enableAlterCss("even", "uneven");

	if (!settings.IsShowGridLines)
		jQuery('head').append("<style type='text/css'>div.gridbox table.obj td { border: 0px none; }</style>");

	var searchFor = tbSearch.getValue('search_for');
	var postalCode = tbSearch.getValue('postal_code');
	var radiusId = tbSearch.getListOptionSelected('radius');
	var radius = radiusId.substring(radiusId.lastIndexOf('_') + 1);

	gridMain.attachEvent("onXLS", function (grid_obj) {
		ShowBusy("Loading...");
	});
	gridMain.attachEvent("onXLE", function (grid_obj) {
		gridMainXLE()
	});

	gridMain.attachEvent("onAfterSorting", function (index, type, direction) {
		setTimeout(function () {
			HideBusy();
		}, 10);
		jQuery('#grid-main, #grid-main div table').css('width', '100%');
		jQuery('#grid-main div table tbody tr th').css('width', '');
		gridMain.setSizes();
		return true;
	});
	gridMain.attachEvent("onBeforeSorting", function (ind, type, direction) {
		setTimeout(function () {
			ShowBusy("Sorting...");
		}, 10);
		jQuery('#grid-main, #grid-main div table').css('width', '100%');
		jQuery('#grid-main div table tbody tr th').css('width', '');
		return true;
	});

	gridMain.attachEvent("onPageChanged", function (ind, fInd, lInd) {
		jQuery('#grid-main, #grid-main div table').css('width', '100%');
		jQuery('#grid-main div table tbody tr th').css('width', '');
		gridMain.setSizes();
	});

	gridMain.attachEvent("onRowDblClicked", function (rId, cInd) {
		if (window.location.href.toLowerCase().indexOf('oreillyplanroom') == -1 && (typeof pjqIsDisablePublicProjectsClick == 'undefined' || !pjqIsDisablePublicProjectsClick)) {
			GoToProject(this.getUserData(rId, 'ProjectKey'));
		}
		else {
			return false;
		}
	});

	gridMain.attachEvent("onBeforeSelect", function (newRowId, oldRowId) {
		if (window.location.href.toLowerCase().indexOf('oreillyplanroom') != -1 || (typeof pjqIsDisablePublicProjectsClick != 'undefined' && pjqIsDisablePublicProjectsClick)) {
			return false;
		}
		else {
			return true;
		}
	});

	gridMain.attachEvent("onRowSelect", function (rId, cInd) {
		if (window.location.href.toLowerCase().indexOf('oreillyplanroom') == -1 && (typeof pjqIsDisablePublicProjectsClick == 'undefined' || !pjqIsDisablePublicProjectsClick)) {
			GoToProject(this.getUserData(rId, 'ProjectKey'));
		}
	});

	var searchState = '';
	var queryString = window.location.search.substring(1);
	var params = queryString.split('&');
	for (var i = 0; i < params.length; i++) {
		if (params[i].startsWith('searchstate=') && params[i].length > 11) {
			searchState = params[i].substring(12);
		}
	}

	let gridUrl = '/DesktopModules/PJQPublicProjects/GetGrid.aspx?sessionid=' + pjqSessionId + '&searchfor=' + encodeURIComponent(searchFor) + '&state=' + searchState + '&zip=' + postalCode + '&radius=' + radius + '&x=' + (new Date).getTime();
	if (window.publicProjectMuid > 0) {
		gridUrl += "&muid=" + window.publicProjectMuid.toString();
	}
	gridMain.loadXML(gridUrl, function () {

	});
}

function gridMainXLE() {
	if (window.location.href.toLowerCase().indexOf('oreillyplanroom') != -1) {
		for (var i = 0; i < gridMain.getRowsNum(); i++) {
			var c = '',
				id = gridMain.getRowId(i),
				s = gridMain.cells(id, 2).getValue().trim().toLowerCase();
			if (s == 'bids under review') {
				c = '#F57C7C';
			}
			else if (s == 'awarded') {
				c = '#FCFF80';
			}
			if (c.length > 0)
				gridMain.setRowColor(id, c);
		}
	}
	HideBusy();
}

function GoToProject(accessKey) {
	var url = '/Default.aspx?tabId=' + settings.ProjectWallSubTabId.toString() + '&projectkey=' + accessKey;

	if (settings.PortalId == 4)
		url = '/Default.aspx?tabId=' + settings.ProjectWallSubMallTabId.toString() + '&projectkey=' + accessKey;

	if (settings.IsAutoFollow)
		url += '&fp=1';

	if (settings.IsBiddingHidden)
		url += '&ad=1';

	if ((settings.UserId < 1 || PJQ.app.session.contact == null || PJQ.app.session.contact.get('masterUserId') === 39) && settings.IsRegRequired) {
		url = '/Default.aspx?tabId=' + settings.UserRegTabId.toString() + '&regcontact=1&projectkey=' + accessKey;
	}
	window.location.href = url;
}

function ShowBusy(message) {
	jQuery('#pjq-busy').html("<img src='/i/ajax-loader.gif' alt='Busy...' style='vertical-align: middle;' /><span style='font-weight: bold;vertical-align: middle; padding-left: 6px;'>" + message + "</span>");
	jQuery("#pjq-busy").removeClass('pjq-hidden');
}

function HideBusy() {
	jQuery("#pjq-busy").addClass('pjq-hidden');
}

function KeepAlive() {
	clearTimeout(pjqKeepAlive);
	jQuery.get('/DesktopModules/PanteraModuleGlobal/KeepAlive.aspx');
	pjqKeepAlive = setTimeout(KeepAlive, 300000);
}

function showInfoDialog(titleText, message, iconClass, context) {
	if (iconClass)
		jQuery('#dialog-message-icon').addClass(iconClass);
	else
		jQuery('#dialog-message-icon').addClass('ui-icon-info');

	jQuery('#dialog-message-context').val(context);

	jQuery('#dlg-message-span').html(message);
	var buttonList = {
		Ok: function () {
			$(this).dialog("close");
		}
	};

	if (context == 'archive-project' || context == 'delete-project' || context == 'restore-project' || context == 'archive-projcontainer' || context == 'delete-projcontainer' || context == 'restore-projcontainer') {
		buttonList = {
			Ok: function () {
				var context = jQuery('#dialog-message-context').val();
				$(this).dialog("close");

				/*
		  if (context == 'archive-project') 
			PanteraScript.PanteraScriptService.ArchiveProjectList(pjqSessionId, selectedRows, actionCompleted, onScriptError);
		  	*/
			},
			Cancel: function () {
				$(this).dialog("close");
			}
		};
	}

	jQuery("#dialog-message").dialog({
		modal: true,
		title: titleText,
		buttons: buttonList
	});
}

function str_ci(a, b, order) { // the name of the function must be > than 5 chars
	if (order == "asc")
		return (a.toLowerCase() > b.toLowerCase() ? 1 : -1);
	else
		return (a.toLowerCase() > b.toLowerCase() ? -1 : 1);
}

function date_pantera(a, b, order) {
	var optionA = null;
	var optionB = null;
	var baseYear = 1900;

	if (a == 'ASAP') {
		optionA = new Date(new Date().setFullYear(2999));
	}
	else {
		try {
			optionA = new Date(a);
		} catch (err) {
			optionA = new Date(new Date().setFullYear(1901));
		}
	}

	if (b == 'ASAP') {
		optionB = new Date(new Date().setFullYear(2999));
	}
	else {
		try {
			optionB = new Date(b);
		} catch (err) {
			optionB = new Date(new Date().setFullYear(1901));
		}
	}

	if (!optionA.getDate()) {
		optionA = new Date(new Date().setFullYear(1901));
	}

	if (!optionB.getDate()) {
		optionB = new Date(new Date().setFullYear(1901));
	}


	if (optionA == optionB)
		return 0;

	if (order == "asc")
		return optionA > optionB ? 1 : -1;
	else
		return optionA < optionB ? 1 : -1;
}
